import React from 'react';
import { IoArrowForward } from 'react-icons/io5';
import FadeInView from '../components/FadeInView';
import './CTASection.css';

const CTASection = () => {
  return (
    <section id="admission" className="cta-section">
      {/* Background Pattern */}
      <div className="cta-pattern" />
      
      {/* Decorative Elements */}
      <div className="cta-decoration cta-decoration-1" />
      <div className="cta-decoration cta-decoration-2" />

      <div className="container-tight cta-content">
        <div className="cta-grid">
          {/* Left Column */}
          <FadeInView direction="left" className="cta-left">
            <div className="cta-left-content">
              <span className="text-label cta-label">BERGABUNG BERSAMA KAMI</span>
              
              <h2 className="text-headline cta-title">
                Jadilah Bagian dari
                <br />
                <span className="cta-title-muted">Generasi Unggul</span>
              </h2>
              
              <p className="cta-description">
                Daftarkan putra-putri Anda sekarang dan mulai perjalanan 
                pendidikan Islami yang berkah bersama Bahrul Ulum.
              </p>
            </div>
          </FadeInView>

          {/* Right Column - CTA */}
          <FadeInView direction="right" className="cta-right">
            <div className="cta-action">
              <a
                href="/admission"
                className="cta-btn"
              >
                Daftar Sekarang
                <IoArrowForward className="cta-btn-icon" />
              </a>
            </div>

            <p className="cta-contact">
              WhatsApp: +62 831-5793-8748
            </p>
          </FadeInView>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
